/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { Module } from 'vuex';

export const types = {
  FETCH_DATA_START: 'FETCH_DATA_START',
  FETCH_DATA_ERROR: 'FETCH_DATA_ERROR',
  FETCH_DATA_SUCCESS: 'FETCH_DATA_SUCCESS',
  ADD_FILTER: 'ADD_FILTER',
  REMOVE_FILTER: 'REMOVE_FILTER',
};

type MboStoreState = {
    isFetching: boolean;
    error: any;
    data: any;
    filters: any;
};

type RootState = {};

const store = {
  namespaced: true,
  state: {
    isFetching: false,
    error: null,
    data: {
      opleidingen: [],
    },
    filters: [],
  },
  mutations: {
    [types.FETCH_DATA_START](state: MboStoreState) {
      state.error = null;
      state.isFetching = true;
    },
    [types.FETCH_DATA_ERROR](state: MboStoreState, payload: any) {
      state.error = payload;
      state.isFetching = false;
    },
    [types.FETCH_DATA_SUCCESS](state: MboStoreState, payload: any) {
      state.data.opleidingen = payload;
      state.isFetching = false;
    },
    [types.ADD_FILTER](state: MboStoreState, payload: any) {
      state.filters.push(payload);
    },
    [types.REMOVE_FILTER](state: MboStoreState, payload: any) {
      const filters = state.filters.filter((filter: { name: any }) => filter.name === payload);

      if (filters.length > 0) {
        const filter = filters[0];
        state.filters.splice(state.filters.indexOf(filter), 1);
      }
    },
  },
  actions: {
    fetchData({ commit }) {
      commit(types.FETCH_DATA_START);
      const API_URL = `${process.env.VUE_APP_API_URL}/mbo`;
      return axios.get(API_URL)
        .then((response) => commit(types.FETCH_DATA_SUCCESS, response.data))
        .catch((error) => commit(types.FETCH_DATA_ERROR, error));
    },
    addFilter({ commit }: any, filter: { name: any }) {
      commit(types.REMOVE_FILTER, filter.name);
      commit(types.ADD_FILTER, filter);
    },
    removeFilter({ commit }: any, filterName: any) {
      commit(types.REMOVE_FILTER, filterName);
    },
  },
  getters: {
    getFiltered: (state: { data: { opleidingen: any }; filters: any[] }) => {
      let filteredData = state.data.opleidingen;

      state.filters.forEach((filter: { method: any }) => {
        filteredData = filteredData.filter(filter.method);
      });

      return filteredData;
    },
    getFetchStatus: (state: { isFetching: any }) => {
      const fetchStatus = state.isFetching;

      return fetchStatus;
    },
  },
} as Module<MboStoreState, RootState>;

export default store;
